var map = {
	"./Air.svg": "Op7E",
	"./Contract.svg": "YCfY",
	"./Credit.svg": "8pCj",
	"./Down-grey.svg": "gLG7",
	"./Down.svg": "rRKW",
	"./Download-blue.svg": "JkJK",
	"./EXL logo.svg": "+wjV",
	"./Frame 214-4.svg": "9BTa",
	"./Group 1706.svg": "ZwFG",
	"./Group 3716.svg": "7ND0",
	"./New-arrow.svg": "0PIq",
	"./Notice.svg": "fOpM",
	"./Notif.svg": "qMJ8",
	"./Ocean.svg": "tReV",
	"./PDF logo.svg": "9r9h",
	"./Quotation.svg": "vM69",
	"./Reorder.svg": "oUY+",
	"./Signal-grey.svg": "S+iI",
	"./Todo.svg": "jwY7",
	"./Totalspen.svg": "mIgD",
	"./Vector.svg": "ZmwL",
	"./VerifiedDoc.svg": "q1U0",
	"./add-button-blue.svg": "pXpk",
	"./add-shipment.svg": "ObWz",
	"./agenda.svg": "uva4",
	"./airplane copy.svg": "HZFJ",
	"./andalinpoint.svg": "/3T+",
	"./arrow-back-full-white.svg": "ThQ6",
	"./arrow-back-full-yellow.svg": "sD0F",
	"./arrow-circle-right.svg": "Wc/m",
	"./arrow-collapse.svg": "lKad",
	"./arrow-down-full-blue.svg": "s7p9",
	"./arrow-down-full-gray.svg": "UVy7",
	"./arrow-right.svg": "1sPO",
	"./attach img.svg": "FYuW",
	"./attach.svg": "q4rB",
	"./attachment.svg": "+gE5",
	"./avatar.svg": "Ic5Q",
	"./bin-blue.svg": "H/0o",
	"./bin-red.svg": "3TPr",
	"./bullet-line-red.svg": "ra+X",
	"./bullet-line.svg": "Tojr",
	"./bullet_line2.svg": "UWGf",
	"./buttonX.svg": "wCid",
	"./calendar.svg": "D/fb",
	"./calendar2.svg": "i5OX",
	"./canceled.svg": "15L+",
	"./cargo-land.svg": "b2rE",
	"./cargo-plane.svg": "mBpc",
	"./cargo-ship.svg": "nnVl",
	"./ceklis-sukses.svg": "U2kG",
	"./chat-attachment.svg": "myU1",
	"./checking.svg": "DzGs",
	"./checklist-success.svg": "mw/J",
	"./cheveron-down.svg": "EJwk",
	"./cheveron-left.svg": "iDEf",
	"./circle-plus-gray.svg": "UTMM",
	"./circle-x-gray.svg": "BCUW",
	"./clipboard-check.svg": "T/MC",
	"./clipboard-list.svg": "3DBM",
	"./clock.svg": "ZEtl",
	"./close-icon.svg": "eZBe",
	"./complate.svg": "ZKpw",
	"./complete-green.svg": "mOn7",
	"./complete.svg": "zr/F",
	"./contract-shipment.svg": "Cmud",
	"./copy-text.svg": "0p2X",
	"./credit-green.svg": "quVV",
	"./cube.svg": "qhXk",
	"./customs.svg": "JPMR",
	"./dashboard-blue-arrow.svg": "RZjU",
	"./dashboard-document.svg": "hM4C",
	"./dashboard-last-month.svg": "uTJ+",
	"./dashboard-notif.svg": "xPmA",
	"./dashboard-overdue.svg": "QdyG",
	"./dashboard-red-alert.svg": "pTie",
	"./dashboard-rejected.svg": "8rPe",
	"./dashboard-roadmap.svg": "uQYO",
	"./dashboard-this-month.svg": "92Ws",
	"./dashboard-this-year.svg": "fjp+",
	"./dashboard-todo.svg": "8TCq",
	"./dashboard-total-cbm.svg": "UQ5m",
	"./dashboard-total-container.svg": "VfT+",
	"./dashboard-total-kg.svg": "EMpt",
	"./dashboard-upcoming.svg": "1O9F",
	"./dashboard-yellow-alert.svg": "kP0/",
	"./details_address.svg": "6C9o",
	"./document-text.svg": "xLW1",
	"./download-blue-medium.svg": "TgQ2",
	"./download-docs.svg": "pe1s",
	"./download-down-blue.svg": "McDB",
	"./download-grey.svg": "pbG9",
	"./download-invoice.svg": "mPq9",
	"./download.svg": "fllZ",
	"./edit-grey.svg": "J0UH",
	"./edit-text-blue.svg": "ci2b",
	"./error-red.svg": "jXgE",
	"./failed.svg": "v3fY",
	"./file-blue.svg": "LELc",
	"./file-format-symbol-doc.svg": "Thp6",
	"./file-format-symbol-docx.svg": "TbA6",
	"./file-format-symbol-exe.svg": "futE",
	"./file-format-symbol-gif.svg": "jVNv",
	"./file-format-symbol-jpeg.svg": "ML7k",
	"./file-format-symbol-jpg.svg": "JfaF",
	"./file-format-symbol-pdf.svg": "LDY7",
	"./file-format-symbol-png.svg": "WrIS",
	"./file-format-symbol-ppt.svg": "bixw",
	"./file-format-symbol-pptx.svg": "M6lU",
	"./file-format-symbol-rar.svg": "1qdM",
	"./file-format-symbol-xls.svg": "fLpe",
	"./file-format-symbol-xlsx.svg": "+VGw",
	"./file-format-symbol-zip.svg": "W5rt",
	"./fireworks.svg": "tBDM",
	"./happy.svg": "7HE5",
	"./house.svg": "jGNn",
	"./icon-air-cargo.svg": "7v4H",
	"./icon-air-courier.svg": "/5/K",
	"./icon-arrow-rigt-left.svg": "CzRV",
	"./icon-dropdown-gray.svg": "BvDa",
	"./icon-file.svg": "wx2c",
	"./icon-filter.svg": "KWR+",
	"./icon-img.svg": "rq41",
	"./icon-land.svg": "t/VU",
	"./icon-location-not-found.svg": "g4Sx",
	"./icon-location.svg": "QNjI",
	"./icon-ocean-fcl.svg": "i3le",
	"./icon-ocean-lcl.svg": "IJvu",
	"./icon-plus.svg": "XNTQ",
	"./icon-rectangle.svg": "tpWj",
	"./icon-sealine-default.svg": "Y2XM",
	"./icon-search-white.svg": "M7+J",
	"./icon-ship.svg": "DW+8",
	"./icon-shipment-breakbulk.svg": "C8dC",
	"./icon-tresh-red.svg": "1A3z",
	"./icon-upload-drag-drop.svg": "3Btx",
	"./icon-upload-drag-dropred.svg": "JuSW",
	"./icon-vessel.svg": "aCna",
	"./iconDown.svg": "qlOm",
	"./iconLink.svg": "eQ3c",
	"./iconUp.svg": "R/ch",
	"./icon_air.svg": "JzDz",
	"./icon_ocean.svg": "sbFr",
	"./information-circle-2.svg": "adkF",
	"./information-circle-3.svg": "wUXJ",
	"./information-circle.svg": "GaEd",
	"./instant-booked.svg": "p+5n",
	"./instant-quote-validating.svg": "k7/E",
	"./lamp.svg": "s+ca",
	"./leaderboard-progress-down.svg": "VyZH",
	"./leaderboard-progress-up.svg": "u0C8",
	"./leaderboard-progress.svg": "WqES",
	"./left-arrow-blue.svg": "+9z1",
	"./left-arrow-yellow.svg": "HH3s",
	"./loading.svg": "YkkU",
	"./location-marker.svg": "SBkD",
	"./man-user.svg": "7Jxj",
	"./message-reply-arrow.svg": "jRy6",
	"./message.svg": "wMgo",
	"./money-bag.svg": "E7UV",
	"./ms-airplane-purple.svg": "deWl",
	"./ms-airplane-red.svg": "DTsy",
	"./ms-airplane.svg": "qary",
	"./ms-bill.svg": "OHKq",
	"./ms-booked-land-blue.svg": "TCmt",
	"./ms-booked-land.svg": "z/sQ",
	"./ms-booked-purple.svg": "RTAX",
	"./ms-booked.svg": "oF8B",
	"./ms-complate-blue.svg": "8DL+",
	"./ms-complate-gray.svg": "y8JX",
	"./ms-complate-red.svg": "Z9Pb",
	"./ms-completed-green.svg": "CX6p",
	"./ms-deliv-purple.svg": "mdVq",
	"./ms-deliv-red.svg": "bkFk",
	"./ms-deliv.svg": "lPgO",
	"./ms-delivered-blue.svg": "Uv4i",
	"./ms-delivered.svg": "sUdG",
	"./ms-handling-purple.svg": "PHkT",
	"./ms-handling-red.svg": "EMj7",
	"./ms-handling.svg": "SvbW",
	"./ms-intransit-blue.svg": "UWWy",
	"./ms-intransit.svg": "Xz39",
	"./ms-loading-blue.svg": "dOkj",
	"./ms-loading.svg": "pp39",
	"./ms-pickup-purple.svg": "MNTP",
	"./ms-pickup.svg": "fwLD",
	"./ms-schedule.svg": "+Yqz",
	"./ms-scheduled-air-purple.svg": "9CYL",
	"./ms-scheduled-land-blue.svg": "J78Z",
	"./ms-scheduled-land.svg": "vke+",
	"./ms-scheduled-ocean-purple.svg": "5/+1",
	"./ms-scheduled-ocean.svg": "P9V6",
	"./ms-ship-red.svg": "qBT6",
	"./ms-ship.svg": "Ter8",
	"./ms-started-blue.svg": "6I1v",
	"./ms-started.svg": "ukg+",
	"./msdetail-note.svg": "H7U9",
	"./msdetail-order-details.svg": "3Upj",
	"./msdetail-origin.svg": "x2nw",
	"./msdetail_carrier.svg": "qMhY",
	"./msdetail_commodity.svg": "U/er",
	"./msdetail_consignee.svg": "9gXF",
	"./msdetail_order_info.svg": "nSZs",
	"./msdetail_shipper.svg": "Xn6J",
	"./netral.svg": "chgF",
	"./new-message.svg": "/GTX",
	"./new-product.svg": "kUk0",
	"./new-rfq.svg": "DIDB",
	"./new-success.svg": "AONJ",
	"./next.svg": "W8Ex",
	"./nodata-older.svg": "iRzx",
	"./nodata-ongoing.svg": "wXHl",
	"./nodata-payment.svg": "Mj28",
	"./nodata-point.svg": "8CQS",
	"./nodata-requestlist.svg": "smKn",
	"./noresult-search-address.svg": "7miJ",
	"./note-text.svg": "ZRdy",
	"./notif-delay.svg": "Vrko",
	"./notification-icon.svg": "5hPE",
	"./ongoing.svg": "6sSa",
	"./others.svg": "WTG7",
	"./pack-bag.svg": "FQXn",
	"./pack-barrels-roll.svg": "jcQy",
	"./pack-box.svg": "sKNQ",
	"./pack-bulk.svg": "mpU/",
	"./pack-pipes.svg": "pG+c",
	"./pack-sacks.svg": "nYPW",
	"./payment-completed.svg": "+2XT",
	"./pdf-logo.svg": "xgYF",
	"./pencil-alt.svg": "N8B7",
	"./pencil-blue-hover.svg": "2mrC",
	"./pencil-blue.svg": "LdTT",
	"./pencil-striped.svg": "vH13",
	"./pencil.svg": "pvWN",
	"./pickup.svg": "NdWn",
	"./pin-point.svg": "Oweb",
	"./plane.svg": "yD5X",
	"./power-off.svg": "5Mdw",
	"./price-changed.svg": "FSCN",
	"./product_details.svg": "X95T",
	"./ready-to-book.svg": "R87N",
	"./receipt.svg": "Ydwm",
	"./reedem-success.svg": "TKG1",
	"./rejected.svg": "7pnw",
	"./rejected_notif.svg": "XcEj",
	"./request-shipment.svg": "AiYx",
	"./right-arrow-blue.svg": "5UrJ",
	"./sb-account.svg": "mfyR",
	"./sb-addresses.svg": "F0rw",
	"./sb-bookmark.svg": "/15E",
	"./sb-bookmarked.svg": "eV75",
	"./sb-documents.svg": "BFiL",
	"./sb-faq.svg": "qCZa",
	"./sb-home.svg": "HShY",
	"./sb-merchant.svg": "LWJC",
	"./sb-payment.svg": "NgYT",
	"./sb-promo.svg": "c2ri",
	"./sb-request.svg": "xMbb",
	"./sb-setting.svg": "6Tm5",
	"./sb-shipment.svg": "p4Wj",
	"./sb-support.svg": "WyZi",
	"./sb-vessel-schedule.svg": "GSQC",
	"./search-location.svg": "EuNV",
	"./search.svg": "7DFY",
	"./shield.svg": "uuaU",
	"./shipment-air-color.svg": "Rt4R",
	"./shipment-air.svg": "sq6S",
	"./shipment-land-color.svg": "blOb",
	"./shipment-land.svg": "8OUy",
	"./shipment-ocean-color.svg": "Y07n",
	"./shipment-ocean.svg": "2bc5",
	"./shipment.svg": "w+o5",
	"./shipment_type.svg": "6Ssu",
	"./sku-notfound.svg": "5lVg",
	"./small-down.svg": "SmoE",
	"./sort-down.svg": "SiEO",
	"./spending.svg": "Y3Jp",
	"./star.svg": "Av0H",
	"./status-green.svg": "Y3WA",
	"./status-grey.svg": "Di5O",
	"./storage-calculator-blue.svg": "eK3x",
	"./storage-calculator-white.svg": "AYMt",
	"./storage.svg": "Ops6",
	"./submited.svg": "zOrZ",
	"./success-blue.svg": "beke",
	"./success-green.svg": "GHZL",
	"./takenajadisabled.svg": "X0wZ",
	"./tekenaja.svg": "tEEW",
	"./tick-circle.svg": "x9jU",
	"./time-left.svg": "LA+j",
	"./todo-icon.svg": "kzpc",
	"./tracking-dots.svg": "Fxrd",
	"./trash-detail.svg": "ORIV",
	"./trash.svg": "I9Xr",
	"./truck-fast.svg": "Dk+m",
	"./unhappy.svg": "oSiN",
	"./union-4.svg": "lESJ",
	"./upload-green.svg": "fn2M",
	"./verified.svg": "kl//",
	"./video-tutorial.svg": "Z06R",
	"./warning-red.svg": "6iLg",
	"./warning.svg": "sa4M",
	"./x-circle.svg": "GZpy"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "exlN";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon ^\.\/.*\.svg$
// module id = exlN
// module chunks = 0